module.exports = __webpack_public_path__ + "img/icon-result3.png";